// extracted by mini-css-extract-plugin
module.exports = {"terms":"styles_terms__24T4v","terms-text--error":"styles_terms-text--error__2NVyn","terms-link":"styles_terms-link__14plZ"};